export default __webpack_public_path__ + "static/media/img-4.9723da35.jpg";